import { multipart_headers } from '../Helper/helper';
import { routes } from '../config/api_routes'

export const promoCodeService = {

    getPromoCode: (formData) => { return window.axios.post(routes.getPromoCodeApi, formData) },

    exportToCsv: () => window.axios.get(routes.promoCodeExportToCsvApi),

    addPromoCode: (formData) => { return window.axios.post(routes.addPromoCodeApi, formData, { headers: multipart_headers() }); },

    getCustomer: (query) => { return window.axios.post(routes.getCustomerLisingApi, query) },

    getProductSearch: (formData) => { return window.axios.post(routes.getProductSearchApi, formData) },
    
    getSubcategorySearch: (formData) => { return window.axios.post(routes.getSubcategorySearchApi, formData) },

    getPromoCodeById: (formData) => { return window.axios.post(routes.getPromoCodeByIdApi, formData) },

    deletePromocode: (formData) => { return window.axios.post(routes.deletePromocodeApi, formData) },

    applyPromoCode: (formData) => { return window.axios.post(routes.applyPromoCodeApi, formData) },

    updatePromoCodeById: (formData) => window.axios.post(routes.updatePromoCodeApi, formData, { headers: multipart_headers() }),
}